/**
 * Kabin kaydındaki bakım listesini kimlik dizisine çevirir (2026-08-24).
 *
 * ── NEDEN AYRI DOSYA ──────────────────────────────────────────────────────
 * `maintenance.services` API'den İKİ biçimde gelebilir:
 *   • ham ObjectId dizisi          (`PUT .../maintenance` yanıtı populate etmez)
 *   • populate edilmiş belge dizisi (`GET /photo-booths` activeActions gibi)
 * İkisini de aynı okuyamazsak modal bazen boş açılır ve yönetici "bakımdan
 * çıktı" sanıp kaydeder — kabin sessizce açılır. Backend'deki
 * `lib/maintenance.js → toMaintenanceIdSet` ile AYNI kural.
 */

type MaintenanceLike =
  | { maintenance?: { services?: unknown } | null }
  | null
  | undefined

/** Bakımdaki hizmet kimlikleri (string). Liste yoksa boş dizi. */
export function maintenanceIdsOf(booth: MaintenanceLike): string[] {
  const raw = booth && booth.maintenance ? booth.maintenance.services : null
  if (!Array.isArray(raw)) return []
  const out: string[] = []
  for (const item of raw) {
    if (!item) continue
    const val =
      typeof item === 'object' && item !== null && '_id' in (item as any)
        ? (item as any)._id
        : item
    if (val === null || val === undefined) continue
    const s = String(val)
    if (s && s !== '[object Object]' && !out.includes(s)) out.push(s)
  }
  return out
}

/** Kabinde bakımda olan hizmet sayısı — satır rozeti bunu gösterir. */
export function maintenanceCountOf(booth: MaintenanceLike): number {
  return maintenanceIdsOf(booth).length
}
